import axios from "../../../util/axios";

const PREFIX_URI = "/project/dev/project";

export default {
    /** 分页查询项目列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data: data}),
    /** 项目详情 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id: id}}),
    /** 保存项目（新增/编辑） */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data: data}),
    /** 项目状态流转 */
    updateStatus: (data) => axios.post({url: `${PREFIX_URI}/updateStatus`, data: data}),
    /** 项目详情-关联迭代批次 */
    queryProjectSprints: (projectId) => axios.get({url: `${PREFIX_URI}/queryProjectSprints`, data: {projectId: projectId}}),
    /** 项目详情-关联任务 */
    queryProjectTasks: (projectId) => axios.get({url: `${PREFIX_URI}/queryProjectTasks`, data: {projectId: projectId}}),
    /** 通用日志查询（按实体类型/实体id） */
    queryLogs: (entityType, entityId) => axios.get({url: `${PREFIX_URI}/queryLogs`, data: {entityType: entityType, entityId: entityId}}),
    /** 项目详情-该项目相关全部日志（entity_type<=100 且 entity_id 以 projectId 为前缀） */
    queryProjectLogs: (projectId) => axios.get({url: `${PREFIX_URI}/queryProjectLogs`, data: {projectId: projectId}}),
    /** 项目详情-参与人（项目人员 + 测试人员） */
    queryProjectPeople: (projectId) => axios.get({url: `${PREFIX_URI}/queryProjectPeople`, data: {projectId: projectId}}),
};
